module.exports = __webpack_public_path__ + "static/media/account_detail_icon_active.dbdc410f.svg";